<template>
    <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab" @tab-click="tabclick">
        <el-tab-pane label="账户报表" name="first">
            <div class="k-page-common">
                <div class="k-common-header">
                    <div class="k-filter-option k-filter-input">
                        <el-input placeholder="请输入账户ID或名称" v-model="searchForm.advertiser_id" :size="size" clearable @change="doSearch"></el-input>
                    </div>
                    <div class="k-filter-option">
                        <div class="k-select-area">
                            <label>项目:</label>
                            <el-select v-model="searchForm.projectId" 
                            :size="size" 
                            clearable 
                            @change="doSearch" 
                            remote
                            reserve-keyword 
                            :remote-method="getProjectLists">
                                <el-option
                                  v-for="item in project_options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="k-close-icon">
                                <i class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                   <div class="k-filter-option">
                        <div class="k-select-area">
                            <label>日期:</label>
                           <el-date-picker 
                              align="center"
                              v-model="searchForm.date"
                              type="daterange"
                              :size="size"
                              value-format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束"
                              @change="doSearch"
                              :picker-options="pickerOptions0"
                              >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="k-common-con">
                    <div class="table_header flex">
                        <h2>详细数据
                            <el-popover
                                placement="right"
                                width="300"
                                trigger="hover"
                                content="1.每天上午10点可以查看前一天数据，当天数据每10分钟同步一次；">
                                <i class="el-icon-question" slot="reference" style="color:#409EFF;"></i> 
                            </el-popover>
                        </h2>
                    </div>
                    <div class="k-table-wrapper">
                        <div class="k-table-con">
                            <el-table
                                :data="tableData.data"
                                border
                                @sort-change="sortChange"
                                style="width: 100%">
                                <el-table-column
                                prop="projectName"
                                fixed
                                label="项目"
                                width="200">
                                </el-table-column>
                                <el-table-column
                                prop="advertiser_id"
                                label="广告主ID"
                                fixed
                                width="170">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                fixed
                                label="广告主名称"
                                width="200">
                                </el-table-column>
                                
                                <el-table-column
                                prop="stat_cost"
                                sortable="custom"
                                label="消耗"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="pay_order_amount"
                                label="成交订单金额"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="prepay_and_pay_order_roi"
                                label="支付roi"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="create_order_amount"
                                label="下单成交金额"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="create_order_roi"
                                label="下单roi"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="show_cnt"
                                label="展示次数"
                                sortable="custom"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="ctr"
                                label="点击率"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="cpm_platform"
                                label="平均千次展示费用"
                                width="130">
                                </el-table-column>
                                <el-table-column
                                prop="click_cnt"
                                label="点击次数"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="pay_order_count"
                                label="成交订单数"
                                width="100">
                                </el-table-column>
                                
                                <el-table-column
                                prop="create_order_count"
                                label="下单订单数"
                                width="120">
                                </el-table-column>
                                
                                
                                <el-table-column
                                prop="dy_follow"
                                label="新增粉丝数"
                                width="120">
                                </el-table-column>
                                
                                <el-table-column
                                prop="prepay_order_count"
                                label="广告预售订单数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="prepay_order_amount"
                                label="广告预售订单金额"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="convert_cnt"
                                label="转化数"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="convert_cost"
                                label="转化成本"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="convert_rate"
                                label="转化率"
                                width="100">
                                </el-table-column>

                                <el-table-column
                                prop="luban_live_enter_cnt"
                                label="直播间观看人次"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="live_watch_one_minute_count"
                                label="直播间超过一分钟观看人次"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="live_fans_club_join_cnt"
                                label="直播间新加团人次"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_slidecart_click_cnt"
                                label="直播间查看购物车次数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_click_product_cnt"
                                label="直播间商品点赞次数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_comment_cnt"
                                label="直播间评论次数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_share_cnt"
                                label="直播间分享次数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_gift_cnt"
                                label="直播间打赏次数"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="luban_live_gift_amount"
                                label="直播间音浪收入"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="live_pay_order_cost_per_order"
                                label="成交客单价"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="dy_like"
                                label="点赞次数"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="dy_share"
                                label="分享次数"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="dy_comment"
                                label="评论次数"
                                width="100">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    ref="pagination"
                                    @current-change="handleCurrentChange"
                                    :current-page="tableData.current_page | number"
                                    :page-size="tableData.per_page | number"
                                    layout="total, prev, pager, next, jumper"
                                    :total="tableData.total | number">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="自定义报表" name="second">
            <div class="k-page-common">
                <div class="k-common-header">
                    <div class="k-filter-option k-filter-input">
                        <el-input placeholder="请输入名称" v-model="customSearchForm.title" :size="size" clearable @change="doCustomSearch"></el-input>
                    </div>
                </div>
                <div class="k-common-con">
                    <div class="table_header flex">
                        <h2>自定义报表</h2>
                        <el-button :size="size" plain @click="fieldSelectionVisible">导出数据 
                            <el-popover
                                placement="top-start"
                                width="150"
                                trigger="hover"
                                content="导出所有页面的数据">
                                <i class="el-icon-question" slot="reference"></i> 
                            </el-popover>
                        </el-button>
                    </div>
                    <div class="k-table-wrapper">
                        <div class="k-table-con">
                            <el-table
                                :data="tableCustomData.data"
                                border
                                @sort-change="sortChange"
                                style="width: 100%">
                                <el-table-column
                                prop="id"
                                label="ID"
                                fixed
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="title"
                                fixed
                                label="标题"
                                width="200">
                                </el-table-column>
                                <el-table-column
                                prop="send_type"
                                label="发送类型"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="send_email"
                                label="接收邮箱"
                                width="200">
                                </el-table-column>
                                <el-table-column
                                prop="send_time_lable"
                                label="发送时间"
                                min-width="501">
                                </el-table-column>
                                <el-table-column
                                prop="nickname"
                                label="添加人"
                                width="200">
                                </el-table-column>
                                <el-table-column
                                prop="create_time"
                                label="创建时间"
                                width="200">
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="200">
                                 <template slot-scope="scope">
                                    <!-- <el-button type="text" :size="size" class="c-danger" @click="editRules(scope.row)" >编辑</el-button> -->
                                    <el-button type="text" :size="size" class="c-danger" @click="deleteRules(scope.row)" >删除</el-button>
                                    <el-button type="text" :size="size" class="c-danger" @click="send(scope.row)" >下载</el-button>
                                  <!--   <el-button type="text" :size="size" class="c-danger" @click="look(scope.row)">查看</el-button> -->
                                 </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    background
                                    ref="pagination"
                                    @current-change="customHandleCurrentChange"
                                    :current-page="tableCustomData.current_page | number"
                                    :page-size="tableCustomData.per_page | number"
                                    layout="total, prev, pager, next, jumper"
                                    :total="tableCustomData.total | number">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="fieldSelection"
        direction="rtl"
        size="50%">
        <div class="drawer-header">
            <div class="header-title">
                <span>导出数据</span>
                <i class="el-icon-close k-drawer-close" @click="closeDrawer"></i>
            </div>
        </div>
        <div class="drawer-content">
        

            <div class="k-field-select">
                <h3>请选择导出的字段</h3>
                <div>

                    <div>
                        <el-checkbox-group v-model="customReport.checkList">
                            <template v-for="(group,key) in checkOption">
                                <el-divider content-position="left">{{key}}</el-divider>
                                 <el-checkbox
                                    v-for="item in group"
                                      :key="item.value"
                                      :label="item.value"
                                      :disabled="item.disabled">{{item.lable}}
                                 </el-checkbox>
                            </template>
                          </el-checkbox-group>
                    </div>
                    <div>
                        <el-checkbox-group v-model="customReport.SendList">
                            <template v-for="(group,key) in sendTimeOption">
                                <el-divider content-position="left">{{key}}</el-divider>
                                 <el-checkbox
                                    v-for="item in group"
                                      :key="item.value"
                                      :label="item.value"
                                      :disabled="item.disabled">{{item.lable}}
                                 </el-checkbox>
                            </template>
                          </el-checkbox-group>
                    </div>
                    <div>
                        <el-divider content-position="left">自定义报表名称</el-divider>
                        <el-input placeholder="请输入自定义报表名称" v-model="customReport.name" :size="size"></el-input>
                    </div>
                    <div>
                        <el-divider content-position="left">发送邮箱</el-divider>
                        <el-input placeholder="请输入邮箱地址" v-model="customReport.email" :size="size"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button type="primary" :size="size" @click='addCustomReportRules'>确定</el-button>
            <el-button :size='size' @click="fieldSelection = false">取消</el-button>
        </div>
    </el-drawer>
    <el-dialog
    title="下载"
    width="30%"
    :visible.sync="downVisible">
        <el-form ref="form" :model="addFoler" :size="size" label-width="95px">
            <el-form-item label="时段">
                <el-select v-model="addFoler.period_time" placeholder="请选择" ref="periodtime">
                    <el-option
                    v-for="item in periodTimeOptions"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="download">下 载</el-button>
        <el-button @click="downVisible = false" :size="size">取 消</el-button>
    </span>
    </el-dialog>
</div>
</template>
<script>
    export default {
        props: ['info'],
        data(){
            return {
                isCollapse: false,
                activeClass: 'el-icon-s-fold',
                activeName: 'first',
                slidewidth: 160,
                loading: false,
                size: 'mini',
                addFoler: {
                    period_time: '',
                },
                periodTimeOptions: [],
                sendid: '',
                searchForm: {
                    advertiser_id: '',
                    projectId: '',
                    date: [this.getNowTime(), this.getNowTime()],
                },
                resetSearch: {
                    advertiser_id: '',
                    projectId: '',
                    date: [this.getNowTime(), this.getNowTime()],
                },
                project_options: [],
                customSearchForm: {
                    title: '',
                },
                customResetSearch: {
                    title: '',
                },
                value: '',
                checked: false,
                tableData: {
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    last_page: 0,
                    data: [],
                },
                tableCustomData: {
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    last_page: 0,
                    data: [],
                },
                pickerOptions0: {
                    disabledDate: function (time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            },
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            },
                        },
                    ],
                },

                fieldSelection: false,

                customReport: {
                    checkList: [
                        'project_name',
                        'advertiser_id',
                        // 'liveroom_name',
                        // 'tiktok_name',
                        'period_time',
                        // 'cpa_bid',
                        'stat_cost',
                    ],
                    SendList: [],
                    name: '',
                    email: '',
                },
                resetCustomReport: {
                    checkList: [],
                    SendList: [],
                    name: '',
                    email: '',
                },

                checkOption: {
                    固定字段: [
                        { lable: '项目', value: 'project_name', disabled: true },
                        { lable: '广告主ID', value: 'advertiser_id', disabled: true },
                        { lable: '时段', value: 'period_time', disabled: true },
                        { lable: '消耗', value: 'stat_cost', disabled: true },
                        // {lable:'直播间',value:'liveroom_name',disabled:true},
                        // {lable:'抖音号',value:'tiktok_name',disabled:true},
                        // {lable:'出价',value:'cpa_bid',disabled:true},
                    ],
                    可选字段: [
                        { lable: '展现次数', value: 'show_cnt' },
                        { lable: '点击次数', value: 'click_cnt' },
                        { lable: '平均千次展现费用', value: 'cpm_platform' },
                        { lable: '转化数 ', value: 'convert_cnt' },
                        { lable: '转化成本', value: 'convert_cost' },
                        { lable: '成交订单数', value: 'pay_order_count' },
                        { lable: '成交订单金额', value: 'pay_order_amount' },
                        { lable: '广告预售订单数', value: 'prepay_order_count' },
                        { lable: '广告预售订单金额', value: 'prepay_order_amount' },
                        { lable: '下单订单数', value: 'create_order_count' },
                        { lable: '下单成交金额', value: 'create_order_amount' },
                        { lable: '新增粉丝数 ', value: 'dy_follow' },
                        { lable: '直播间观看人次', value: 'luban_live_enter_cnt' },
                        { lable: '直播间超过一分钟观看人次', value: 'live_watch_one_minute_count' },
                        { lable: '直播间新加团人次', value: 'live_fans_club_join_cnt' },
                        { lable: '直播间查看购物车次数', value: 'luban_live_slidecart_click_cnt' },
                        { lable: '直播间商品点赞次数', value: 'luban_live_click_product_cnt' },
                        { lable: '直播间评论次数', value: 'luban_live_comment_cnt' },
                        { lable: '直播间分享次数', value: 'luban_live_share_cnt' },
                        { lable: '直播间打赏次数', value: 'luban_live_gift_cnt' },
                        { lable: '直播间音浪收入', value: 'luban_live_gift_amount' },
                        { lable: '成交客单价', value: 'live_pay_order_cost_per_order' },
                    ],
                    率: [
                        { lable: '点击率', value: 'ctr' },
                        { lable: '支付roi ', value: 'prepay_and_pay_order_roi' },
                        { lable: '下单roi ', value: 'create_order_roi' },
                        { lable: '转化率', value: 'convert_rate' },
                    ],
                },

                sendTimeOption: {
                    发送时间: [
                        { lable: '0点', value: '0' },
                        { lable: '1点', value: '1' },
                        { lable: '2点', value: '2' },
                        { lable: '3点', value: '3' },
                        { lable: '4点', value: '4' },
                        { lable: '5点', value: '5' },
                        { lable: '6点', value: '6' },
                        { lable: '7点', value: '7' },
                        { lable: '8点', value: '8' },
                        { lable: '9点', value: '9' },
                        { lable: '10点', value: '10' },
                        { lable: '11点', value: '11' },
                        { lable: '12点', value: '12' },
                        { lable: '13点', value: '13' },
                        { lable: '14点', value: '14' },
                        { lable: '15点', value: '15' },
                        { lable: '16点', value: '16' },
                        { lable: '17点', value: '17' },
                        { lable: '18点', value: '18' },
                        { lable: '19点', value: '19' },
                        { lable: '20点', value: '20' },
                        { lable: '21点', value: '21' },
                        { lable: '22点', value: '22' },
                        { lable: '23点', value: '23' },
                    ],
                },
                downVisible: false,
            };
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            },
        },
        computed: {},
        methods: {
            //获取项目列表
            getProjectLists: function (query) {
                this.$api.http.get('adPromotion/getProjectLists',{ name: query }).then(res=>{
                    if (res.code === 0) {
                            this.project_options = res.data;
                        }
                });
            },
            send: function (val) {
                this.$set(this.addFoler, 'period_time', '');
                this.$api.http.get('adPromotion/downloadCutomReport',{ cid: val.id }).then(res=>{
                    if (res.code === 0) {
                            this.downVisible = true;
                            this.sendid = val.id;
                            this.periodTimeOptions = res.data;
                        }
                    this.loading=false;
                })
            },
            download: function (params) {
                this.downVisible = false;
                window.location.href =
                    '/v1/home/downloadRules.html?cid=' +
                    this.sendid +
                    '&period_time=' +
                    this.addFoler.period_time +
                    '&send=1';
            },
            deleteRules: function (params) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(
                    function () {
                        this.loading=true;
                        this.$api.http.post('adPromotion/delCustomReportRules',{ id: params.id }).then(res=>{
                            if (res.code === 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除',
                                    type: 'success',
                                });
                                this.customHandleSearch(this.customSearchForm);
                            }
                            this.loading=false;
                        })
                    }.bind(this)
                );
            },
            tabclick: function (tab) {
                if (tab.name == 'first') {
                    this.handleSearch(this.searchForm);
                } else if (tab.name == 'second') {
                    this.activeName = tab.name;
                    this.customHandleSearch(this.customSearchForm);
                }
            },
            addCustomReportRules: function () {
                //导出字段
                var params1 = [];
                var data1 = this.checkOption;
                for (let key1 in data1) {
                    data1[key1].forEach(
                        function (item, index) {
                            if (this.customReport.checkList.indexOf(item.value) != -1) {
                                params1.push({ lable: item.lable, value: item.value });
                            }
                        }.bind(this)
                    );
                }
                //发送时间
                var param2 = this.customReport.SendList;
                // console.log(param2);
                var params2 = [];
                var data2 = this.sendTimeOption;
                for (let key2 in data2) {
                    data2[key2].forEach(
                        function (item, index) {
                            if (param2.indexOf(item.value) != -1) {
                                params2.push({ lable: item.lable, value: item.value });
                            }
                        }.bind(this)
                    );
                }
                if (params2.length < 1) {
                    this.$message({ showClose: true, message: '发送时间不能为空', type: 'error' });
                    return;
                }
                if (!this.customReport.name) {
                    this.$message({
                        showClose: true,
                        message: '自定义报表标题不能为空',
                        type: 'error',
                    });
                    return;
                }
                if (!this.customReport.email) {
                    this.$message({
                        showClose: true,
                        message: '发送邮箱不能为空',
                        type: 'error',
                    });
                    return;
                }
                //最终传参
                var params3 = [];
                params3.push({
                    fields: params1,
                    sendTime: params2,
                    name: this.customReport.name,
                    email: this.customReport.email,
                });
                var new_params = JSON.stringify(params3);
                this.$api.http.get('adPromotion/addCustomReportRules',new_params).then(res=>{
                    if (res.code === 0) {
                        this.$message({
                            showClose: true,
                            message: '添加成功',
                            type: 'success',
                        });
                        this.fieldSelection = false;
                        this.cstomReport = this.resetCustomReport;
                        this.customHandleSearch(this.customSearchForm);
                    } else {
                        var message = '添加失败0';
                        this.$message({ showClose: true, message: message, type: 'error' });
                    }
                });
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear(); //得到年份
                var month = now.getMonth(); //得到月份
                var date = now.getDate(); //得到日期
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;

                return defaultDate;
            },
            // 执行查询
            doSearch: function (event) {
                var query = this.searchForm;
                query['_t'] = Date.parse(new Date());
                this.$router.push({ path: this.$route.path, query: query });
            },
            // 执行查询
            doCustomSearch: function (event) {
                var query = this.customSearchForm;
                query['_t'] = Date.parse(new Date());
                this.$router.push({ path: this.$route.path, query: query });
            },

            // 排序
            sortChange: function (e) {
                var order;
                var prop = e.prop;
                if (e.order == 'ascending') {
                    order = 'asc';
                } else if (e.order == 'descending') {
                    order = 'desc';
                } else {
                    prop = this.resetSearch.prop;
                    order = this.resetSearch.order;
                }
                this.handleSearch(this.searchForm, 1, prop, order);
            },

            // 改变当前页 page
            handleCurrentChange: function (val) {
                this.handleSearch(this.searchForm, val);
            },
            // 账户报表公共请求接口
            handleSearch: function (params, page, prop, order) {
                this.loading=true;

                var param = Object.assign({}, params);

                param['page'] = page ? page : 1;
                param['prop'] = prop ? prop : 'stat_cost';
                param['order'] = order ? order : 'desc';
                this.$api.http.get('adPromotion/avertiserReportList',param).then(res=>{
                    if (res.code === 0) {
                        this.tableData = res.data;
                        this.$message({
                            showClose: true,
                            message: '查询列表信息成功！',
                            type: 'success',
                        });
                    } else {
                        var message = '查询列表信息失败！';
                        if (res.message) {
                            message = res.message;
                        }
                        this.$message({ showClose: true, message: message, type: 'error' });
                    }
                    this.loading=false;
                });
            },
            // 改变当前页 page
            customHandleCurrentChange: function (val) {
                this.customHandleSearch(this.customSearchForm, val);
            },
            // 自定义公共请求接口
            customHandleSearch: function (params, page, prop, order) {
                this.loading=true;
                var param = Object.assign({}, params);
                param['page'] = page ? page : 1;
                param['prop'] = prop ? prop : 'id';
                param['order'] = order ? order : 'desc';
                this.$api.http.get('adPromotion/getCustomReportRulesList',param).then(res=>{
                    if (res.code === 0) {
                        this.tableCustomData = res.data;
                        this.$message({
                            showClose: true,
                            message: '查询列表信息成功！',
                            type: 'success',
                        });
                    } else {
                        var message = '查询列表信息失败！';
                        if (res.message) {
                            message = res.message;
                        }
                        this.$message({ showClose: true, message: message, type: 'error' });
                    }
                    this.loading=false;
                })
            },
            // 生成查询参数
            makeParams: function (query, data) {
                var params = {};
                params['advertiser_id'] = query.advertiser_id
                    ? query.advertiser_id
                    : this.resetSearch.advertiser_id;
                params['projectId'] = query.projectId
                    ? query.projectId
                    : this.resetSearch.projectId;
                params['date'] = query.date ? query.date : this.resetSearch.date;
                this.searchForm = params;
                return params;
            },
            // 生成查询参数
            makeCustomParams: function (query, data) {
                var params = {};
                params['title'] = query.title ? query.title : this.customResetSearch.title;

                this.customSearchForm = params;
                return params;
            },
            closeDrawer: function () {
                this.fieldSelection = false;
            },
            fieldSelectionVisible: function () {
                this.fieldSelection = true;
            },
        },
        beforeRouteUpdate: function (to, from, next) {
            if (this.activeName == 'first') {
                var params = this.makeParams(to.query);
                this.handleSearch(params);
            } else if (this.activeName == 'second') {
                var customParams = this.makeCustomParams(to.query);
                this.customHandleSearch(customParams);
            }

            next();
        },
        mounted: function () {
            if (this.activeName == 'first') {
                var params = this.makeParams(this.$route.query);
                this.handleSearch(params);
                this.getProjectLists();
            } else if (this.activeName == 'second') {
                var customParams = this.makeCustomParams(this.$route.query);
                this.customHandleSearch(customParams);
            }
        },
    }
</script>
<style>
    .k-field-select .el-checkbox{
        width: 150px;
        margin-right: 10px;
        margin-bottom: 10px;
        display: inline-flex;
        align-items: center;
    }
    .k-field-select .el-checkbox__label{
        text-overflow:ellipsis;
        width: 135px;
        overflow: hidden;
    }
</style>